import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {Text, TextSize} from '@Components/text';
import styles from './replace-media-control-item.module.scss';

interface ReplaceMediaControlItemProps {
  icon: string;
  text: string;
  onClick(): void;
}

export function ReplaceMediaControlItem({...props}: ReplaceMediaControlItemProps): ReactElement {
  return (
    <li
      onClick={(): void => {
        props.onClick();
      }}
      className={`${styles.mediaItem} flex-v-row flex-items-center radius-4 border-s-darker`}
    >
      <Icon icon={props.icon} />
      <Text className="content-sub-text" size={TextSize.XXSMALL} val={props.text} />
    </li>
  );
}
